/* import __COLOCATED_TEMPLATE__ from './disableable-switcher.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { notImplemented, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import { computed } from '@ember/object';
export default Component.extend({
  attributeBindings: ['data-test-logical-switcher', 'data-test-user-switcher'],
  isDisabled: false,
  isForceDisabled: false,
  disabledTooltipContent: '',
  forceDisabledTooltipContent: '',
  tooltipContent: ternaryToProperty('isForceDisabled', 'forceDisabledTooltipContent', 'disabledTooltipContent'),
  tooltipIsDisabled: computed('isDisabled', 'isForceDisabled', 'tooltipContent', function () {
    return !this.tooltipContent || this.tooltipContent && !(this.isDisabled || this.isForceDisabled);
  }),
  readOnlyValue: computed('items', 'selected', function () {
    return this.items.find(item => item.value === this.selected)?.text;
  }),
  items: notImplemented('Predicates Switcher: items is a required property')
});